// extracted by mini-css-extract-plugin
export default {"videoDetailSeriesSelect":"WSPEJ","fullWidth":"W_gvI","headerContainer":"GDHqp","seriesSeasonLink":"qtwsz","placeholderContainer":"WaaN_"};